<template>

  <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="8" md="6" class="pt-6 pb-6">
            <span class="headline font-weight-light">
                    Popis županijskih koordinatora
                    <v-icon slot="divider" @click="getData()" style="padding-bottom: 2px;">mdi-refresh</v-icon>
                </span>

        <v-breadcrumbs :items="breadcrumbs" style="padding-left: 0; padding-bottom: 0;">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>


      </v-col>

    </v-row>
    <v-row :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <template v-for="(item, i) in popis.data" >
        <v-col cols="12" md="6" :key="i">
          <v-card outlined class="px-3" height="100%">
            <v-row>
              <v-col cols="3">
                <div style="background-color: #004379; border-radius: 4px" class="text-center py-5">
                  <v-icon size="50" color="white">mdi-clipboard-account</v-icon>
                </div>
              </v-col>

              <v-col cols="9">
                <div class="text-h7 grey--text"> <b>Ime i prezime:</b> {{item.user.full_name}}</div>
                <div class="text-h7 grey--text"> <b>eduID:</b> {{item.user.aai_email}}</div>
                <div class="text-h7 grey--text"> <b>Mobitel:</b> {{item.user.phone}}</div>
                <!--                                <div class="text-h7 grey&#45;&#45;text">  {{item.user.has_identity}}</div>-->
                <div class="text-h7 grey--text"> <b>Naziv županije:</b> {{item.organisation.title}}</div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import {serverBus} from "../../main";
import ApiV2 from '../../services/ApiV2'

export default {
  components: {
  },

  created: function () {
    this.getData();
    serverBus.$on('reload-all-data', () => {
      this.getData();
    })
  },


  mounted: function () {

  },

  methods: {
    getData() {
      serverBus.$emit('perform-layout-loading', true);

      ApiV2.get('get_coordinators', {
        params: {
          role_id: 2,
          perPage: -1
        }
      }).then((response) => {
        this.popis = response.data;

      }).catch(() => {
        serverBus.$emit('perform-layout-loading', false);

        serverBus.$emit('show-snackbar', false, 'Problem sa popisom županijskih koordinatora.')

      }).finally(() => {

        serverBus.$emit('perform-layout-loading', false);
      });
    },

  },

  data: function () {
    return {
      popis: [],
      breadcrumbs: [{text: "Administracija"}, {text: "Izvještaji"}, {text: "Popis županijskih koordinatora"}],
    }
  },
}

</script>

<style scoped>

</style>